import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { currency } from 'app/constants/currency.constants';
import { messages } from 'app/constants/messages';
import { HelperService, CalculationService, DataService } from 'app/services';
import { findIndex } from 'lodash';

@Component({
  selector: 'app-tire-global-cart',
  templateUrl: './tire-global-cart.component.html',
  styleUrls: ['./tire-global-cart.component.scss'],
})
export class TireGlobalCartComponent implements OnInit {
  @Input() isRunTireStorageFlow: boolean = false;
  @Input() globalCartItemList: any[] = [];
  @Input() cartitemList: any = [];
  @Input() source: string = '';
  @Input() shippingLoader = {};
  @Input('globalCartOrderTotal')
  set globalCartOrderTotal(orderTotal: number) {
    this.selectActiveTabIndex(this.selectedActiveTab);
    this.cartOrderTotal = orderTotal;
    this.calculateAdonServiceTotal();
  }
  @Input() isShippingCalculating: boolean = false;
  @Input() isSubmitting: boolean = false;
  @Input() isOpenFromQuickTireLookup: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() hideCost: boolean = false;
  @Input() adOnServicesObj: any = {};
  @Input('defaultAdonService')
  set setDefaultAdonService(obj: any) {
    if (Object.keys(obj)?.length) {
      this.selectedAdonService = this.helperService.deepCopy(obj);
      this.handleGlobalSelectedQtyChange();
      this.calculateAdonServiceTotal(true);
    }
  }
  @Input('selectedTab')
  set selectedTab(value: number) {
    this.selectActiveTabIndex(value);
    this.selectedActiveTab = value;
  }
  @Input('estimateServices')
  set estimateServiceData(data: any[]) {
    this.services = this.helperService.deepCopy(data);
  }
  @Input('setSelectedQty')
  set setSelectedQty(qty: number) {
    if (qty) {
      this.selectedQty = qty;
      this.handleGlobalSelectedQtyChange();
      this.calculateAdonServiceTotal(true);
    }
  }
  @Input() isEditMode: boolean = false;
  @Input() isAllCountAvailable: boolean = false;
  @Input() roCode: string = '';
  @Input() isPassThroughTaxEnable: boolean = false;
  @Input() isTireStorage2Enabled: boolean = false;
  @Input('setSelectedTax')
  set setSelectedTax(tax: any) {
    this.selectedTax = tax;
    this.calculateAdonServiceTotal(true);
  }

  @Output() closeCart = new EventEmitter();
  @Output() appOnFocus = new EventEmitter();
  @Output() appOnBlur = new EventEmitter();
  @Output() appOnTireSelect = new EventEmitter();
  @Output() appOnCountChange = new EventEmitter();
  @Output() appOnOpenSupplierDropDown = new EventEmitter();
  @Output() appOnSave = new EventEmitter();
  @Output() appOnSelectDelivery = new EventEmitter();
  @Output() appOnAddCustomerAndVehicle = new EventEmitter();
  @Output() appOnAdonServiceTotalChange = new EventEmitter();

  @ViewChild('globalCartContainer', { static: true })
  globalCartContainer: ElementRef;
  tireConnectErrors: any = {};

  usd: string = currency.USD;
  selectedAdonService: any = {
    serviceTotal: {
      serviceTotalPrice: 0,
      serviceTotalCost: 0,
      serviceTotalTax: 0,
      serviceTotalAmount: 0,
    },
  };
  displayDetails = {
    tireconnect: {
      logo: 'assets/img/tireconnect-global.svg',
      alt: 'TireConnect Logo',
      heading: 'TireConnect',
    },
    tirehub: {
      logo: 'assets/img/Tirehub_Logo.svg',
      alt: 'TireHub Logo',
      heading: 'TireHub',
    },
    autoleap: {
      logo: 'assets/img/AL_Logo.svg',
      alt: 'AL Inventory Logo',
      heading: 'AL Inventory',
    },
  };

  icons: any = {
    hazmatFee: 'fa-hard-hat',
    labor: 'fa-user-hard-hat',
    part: 'fa-tools',
    tire: 'fa-tire',
    sublet: 'fa-store',
    bundle: 'fa-box',
    other: 'fa-list-alt',
  };

  outTheDoorPrice: number = 0;
  cartOrderTotal: number = 0;
  searchFilter: any = {
    isSearchEnable: true,
    searchPlaceholder: 'Search',
    serachField: 'title',
    maxLength: 1000,
  };
  activeIndex: number = 0;
  selectedActiveTab: number = 0;

  sourceTabMapping: any = {
    0: 'autoleap',
    1: 'tirehub',
    2: 'tireconnect',
  };
  services: any[] = [];
  globalCartSelctedService: any = {
    serviceTotal: {
      serviceTotalPrice: 0,
      serviceTotalCost: 0,
      serviceTotalTax: 0,
      serviceTotalAmount: 0,
    },
  };
  selectedQty: number = 4;
  selectedTax: any = {};

  constructor(private helperService: HelperService, private calculationService: CalculationService, private dataService: DataService, private renderer: Renderer2) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.target === this.globalCartContainer.nativeElement) {
        this.handleCloseCart();
      }
    });
  }

  ngOnInit(): void {
    this.calculateAdonServiceTotal();
  }

  handleCloseCart() {
    this.tireConnectErrors = {};
    this.closeCart.emit(false);
  }

  handleFocus(tireId: string) {
    this.appOnFocus.emit(tireId);
  }

  handleBlur(tireId: string) {
    this.appOnBlur.emit(tireId);
  }

  handleTireSelect(tireId: string, tire: any, source: string) {
    if (source === 'tireconnect') {
      this.tireConnectErrors = {};
    }
    this.dataService.sendData(this.dataService.typePassData('handleTireSelect', { tireId: tireId, tire: tire, source }));
  }

  handleGlobalSelectedQtyChange() {
    if (this.selectedAdonService.items?.length) {
      this.selectedAdonService.items.forEach((item: any) => {
        if (item?.adjQtyWithTire) {
          const defaultQty = item.defaultQty || item.count;
          item.count = defaultQty * this.selectedQty;
          item.defaultQty = defaultQty;
        }
        if (item.type === 'tireStorage' && this.isTireStorage2Enabled) {
          if (item.count > 6) {
            item.count = '6';
          }
        }
      });
    }
  }

  isValidData(item: any, count: number) {
    if ((item?.totalAvailable || item?.countAvailable) < count) {
      item.error = true;
      item.errorMsgQty = 'Cannot add more than available qty';
    } else {
      item.error = false;
      item.errorMsgQty = '';
      return true;
    }
    return false;
  }

  handleValidate() {
    let obj: any = {
      isValid: true,
    };
    //let isValid: boolean = true;

    for (const cart of this.globalCartItemList) {
      for (const warehouse of cart.cartitemList) {
        for (const item of warehouse?.tires) {
          if ((item?.totalAvailable || item?.countAvailable) < item.count) {
            item.error = true;
            item.errorMsgQty = 'Cannot add more than available qty';
            obj.isValid = false;
            //obj.errorMsgQty = `Cannot add more than available qty`;
          } else {
            item.error = false;
          }

          if (cart?.source === 'tireconnect') {
            if (warehouse?.supplierFields?.length) {
              warehouse?.supplierFields?.forEach((suppField: any) => {
                if (suppField?.options?.length) {
                  if (!this.tireConnectErrors[suppField?.attributes?.name]) {
                    this.tireConnectErrors[suppField?.attributes?.name] = { deliveryMethodError: false };
                  }
                  if (!warehouse?.selectedSupplierFields || !warehouse?.selectedSupplierFields[suppField?.attributes?.name]) {
                    this.tireConnectErrors[suppField?.attributes?.name].deliveryMethodError = true;
                    obj.isValid = false;
                    obj.errorMsgDeliveryMtd = `Please fill all supplier fields to proceed.`;
                  }
                }
              });
            } else {
              const deliveryMethodsAvailable = warehouse?.supplierFields || warehouse?.options;
              if (!warehouse?.delivery?.option?.value && deliveryMethodsAvailable?.length) {
                item.deliveryMethodError = true;
                obj.isValid = false;
                obj.errorMsgDeliveryMtd = `Please fill all supplier fields to proceed.`;
              } else {
                item.deliveryMethodError = false;
              }
            }
          }
        }
      }
    }
    return obj;
  }

  handleCountChange(tireId: string, count: number = 0, item: any, source: string) {
    item.count = count;
    if (this.isValidData(item, count)) {
      this.dataService.sendData(this.dataService.typePassData('handleCountChange', { tireId, count: count, source }));
    }
    // else {
    //   this.helperService.showToaster('error', `Cannot add more than available qty`);
    // }
  }

  getSupplierFields(warehouse: any, source: string) {
    if (!warehouse?.supplierFields?.length) {
      this.dataService.sendData(this.dataService.typePassData('getSupplierFields', { warehouse, source }));
      //this.appOnOpenSupplierDropDown.emit(warehouse);
    }
  }

  getSelectedValue(selectedFields: any, key: string) {
    if (selectedFields && selectedFields[key]) {
      return selectedFields[key];
    }

    return null;
  }

  handleSaveCart(action: string) {
    const obj = this.handleValidate();
    if (obj.isValid) {
      this.appOnSave.emit({ adonServices: this.getSelectedCheckedServiceAdons(), action, cartOutTheDoor: { outTheDoorPrice: this.outTheDoorPrice } });
    } else {
      this.helperService.showToaster('error', obj?.errorMsgQty || obj?.errorMsgDeliveryMtd);
    }
  }

  handleAddCustomerAndVehicleCart(action: string) {
    const obj = this.handleValidate();
    if (obj.isValid) {
      this.appOnAddCustomerAndVehicle.emit({
        adonServices: this.getSelectedCheckedServiceAdons(),
        action,
        cartOutTheDoor: { outTheDoorPrice: this.outTheDoorPrice },
        selectedTax: this.helperService.deepCopy(this.selectedTax),
        isRunTireStorageFlow: this.isRunTireStorageFlow
      });
    } else {
      this.helperService.showToaster('error', obj?.errorMsgQty || obj?.errorMsgDeliveryMtd);
    }
  }

  getSelectedCheckedServiceAdons(): any {
    const serviceAdons: any = this.helperService.deepCopy(this.selectedAdonService);
    serviceAdons.items = this.selectedAdonService?.items?.filter((item: any) => item?.checked) || [];
    serviceAdons.items?.forEach((item) => {
      if (item.type === 'bundle' && item.subTotal) {
        item.netSubTotal = item.subTotal;
      }
    });
    return serviceAdons;
  }

  handleDeliverSelect(warehouse: any, delivery: any, item: any, supplierField: any, source: string) {
    if (item) {
      if (this.isValidData(item, item.count || 0)) {
        if (delivery) {
          item.deliveryMethodError = false;
          if (source === 'tireconnect') {
            if (!this.tireConnectErrors[supplierField?.attributes?.name]) {
              this.tireConnectErrors[supplierField?.attributes?.name] = { deliveryMethodError: false };
            }
            this.tireConnectErrors[supplierField?.attributes?.name].deliveryMethodError = false;
          }
        }
        this.dataService.sendData(this.dataService.typePassData('handleDeliverSelect', { warehouse, delivery, supplierField, source }));
        this.globalCartItemList.map((cart) => {
          if (cart.source === 'tireconnect') {
            cart.cartitemList.forEach((cart: any) => {
              if (cart?.warehouseId === warehouse.warehouseId) {
                if (!cart.delivery) {
                  cart.delivery = {};
                }
                cart.delivery.option = delivery;
              }
            });
          }
        });
      }
      //else {
      //this.helperService.showToaster('error', `Cannot add more than available qty`);
      //}
    }
  }

  handleAddOnService(event: any) {
    this.selectedAdonService = event;
    this.handleGlobalSelectedQtyChange();
    this.calculateAdonServiceTotal();
  }

  handleAddOnItemChange(key: string, event: any, item: any) {
    item[key] = event;

    if (key === 'checked') {
      this.calculateAdonServiceTotal();
    }
  }

  handleAdOnServiceFocus(key: string, item: any) {
    item[key] = true;
  }

  handleAdOnServiceBlur(key: string, item: any) {
    item[key] = false;
    if (key === 'isCountFocus') {
      if (item.type === 'tireStorage' && this.isTireStorage2Enabled) {
        if (item.count > 6) {
          this.helperService.showToaster('error', messages.tireStorageCountMessage);
          setTimeout(() => {
            item.count = '6';
            this.calculateAdonServiceTotal();
          }, 500);
        }
      }
      else this.calculateAdonServiceTotal();
    }
  }

  calculateAdonServiceTotal(isCallFromSetter?: boolean) {
    const obj: any = this.calculationService.calculateOutTheDoorPrice(this.selectedAdonService.items);
    const taxCalculated: any = this.calculationService.calculateOrderItemTaxes({
      total: obj.serviceTotalTaxAbleAmt,
      taxRates: this.selectedTax?.taxRates || [],
      roundOffTax: false,
    });
    this.selectedAdonService.serviceTotal.serviceTotalTax = taxCalculated?.taxAmt || 0;
    this.selectedAdonService.serviceTotal.serviceTotalAmount = (taxCalculated?.taxAmt || 0) + obj.serviceTotalPrice;
    this.selectedAdonService.serviceTotal.serviceTotalPrice = obj.serviceTotalPrice;
    this.selectedAdonService.serviceTotal.serviceTotalCost = obj.serviceTotalCost;
    this.outTheDoorPrice = this.cartOrderTotal + this.selectedAdonService.serviceTotal.serviceTotalAmount;
    if (isCallFromSetter) {
      this.appOnAdonServiceTotalChange.emit({ defaultServiceTotal: obj.serviceTotalPrice, serviceTotalTaxAbleAmt: obj.serviceTotalTaxAbleAmt });
    } else {
      this.appOnAdonServiceTotalChange.emit({ defaultServiceTotal: obj.serviceTotalPrice, selectedAdonService: this.selectedAdonService, serviceTotalTaxAbleAmt: obj.serviceTotalTaxAbleAmt });
    }
  }

  selectActiveTabIndex(value: number) {
    if (this.globalCartItemList && this.globalCartItemList?.length) {
      const index = findIndex(this.globalCartItemList, { source: this.sourceTabMapping[value] });
      if (index > -1) {
        this.activeIndex = index;
      } else {
        this.activeIndex = 0;
      }
    }

    this.setAssociatedServiceItems();
  }

  setAssociatedServiceItems() {
    if (this.isEditMode) {
      let globalServices: any[] = [];
      let servicesTitles: string[] = [];
      let serviceAdonItems: any[] = [];
      if (this.services?.length) {
        this.services.forEach((service: any) => {
          if (service.items?.length) {
            const onlineOrderItems: any = service.items?.filter((item: any) => ['TireHub', 'TireConnect'].includes(item.itemSource) && item.orderItemId);
            if (onlineOrderItems?.length) {
              const serviceItems: any[] =
                service.items?.filter((item: any) => {
                  if (!['TireHub', 'TireConnect'].includes(item.itemSource) && !item.orderItemId && item.type) {
                    item.checked = true;
                    return item;
                  }
                }) || [];
              serviceAdonItems = [...serviceAdonItems, ...serviceItems];
            }
            servicesTitles.push(service.title);
          }
        });
      }

      const obj = {
        serviceTotal: {
          serviceTotalPrice: 0,
          serviceTotalCost: 0,
          serviceTotalTax: 0,
          serviceTotalAmount: 0,
        },
        title: `${servicesTitles.join(' ')} (RO# ${this.roCode})`,
        items: serviceAdonItems,
        _id: '',
      };
      this.adOnServicesObj.adOnServices.push(obj);
      this.globalCartSelctedService = obj;
      this.calculateGlobalAdonServiceTotal();
      console.log(obj);
    }
  }

  calculateGlobalAdonServiceTotal() {
    const obj: any = this.calculationService.calculateOutTheDoorPrice(this.globalCartSelctedService.items);
    const taxCalculated: any = this.calculationService.calculateOrderItemTaxes({
      total: obj.serviceTotalTaxAbleAmt,
      taxRates: this.selectedTax?.taxRates || [],
      roundOffTax: false,
    });
    this.globalCartSelctedService.serviceTotal.serviceTotalTax = taxCalculated?.taxAmt || 0;
    this.globalCartSelctedService.serviceTotal.serviceTotalAmount = (taxCalculated?.taxAmt || 0) + obj.serviceTotalPrice;
    this.globalCartSelctedService.serviceTotal.serviceTotalPrice = obj.serviceTotalPrice;
    this.globalCartSelctedService.serviceTotal.serviceTotalCost = obj.serviceTotalCost;
    this.outTheDoorPrice = this.cartOrderTotal + this.globalCartSelctedService.serviceTotal.serviceTotalAmount;
    this.appOnAdonServiceTotalChange.emit({ defaultServiceTotal: obj.serviceTotalPrice, serviceTotalTaxAbleAmt: obj.serviceTotalTaxAbleAmt });
  }
}
